export default __webpack_public_path__ + "static/media/lore.546bfc95.png";